import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { CrossSolidIcon } from '@compono/ui-icons';
import { useTheme } from '../hooks/useTheme.js';
import { IconButton } from '../IconButton/IconButton.js';

var DialogCloseButton = forwardRef(function DialogCloseButton(_a, ref) {
    var sx = _a.sx, children = _a.children, props = __rest(_a, ["sx", "children"]);
    var mergeStyles = useTheme().mergeStyles;
    var baseStyle = mergeStyles([
        {
            position: "absolute",
            right: 0,
            top: 0,
            mx: 5,
            my: "20px",
            color: "black.60",
            backgroundColor: "white",
            ":hover": {
                backgroundColor: "primary.10",
            },
        },
        sx,
    ]);
    return (jsx(IconButton, __assign({ ref: ref, size: "sm", tone: "secondary", look: "naked", label: "Close dialog", rounded: true, sx: baseStyle, type: "button" }, props, { children: children || jsx(CrossSolidIcon, {}) })));
});

export { DialogCloseButton };
//# sourceMappingURL=DialogCloseButton.js.map
